import { useQuery, useQueryClient } from '@tanstack/react-query'

import { clearAccessToken } from '@/shared/lib/auth/token-storage'

import { useSignOutMutation } from '../api/mutations'
import { sessionQueries } from '../api/queries'

/**
 * Reads the current user from the session query. Inside `/_app` it resolves
 * synchronously: the route guard already populated this cache entry via
 * `ensureQueryData` and the query is `staleTime: Infinity`.
 */
export const useSession = () => {
	const { data: user } = useQuery(sessionQueries.currentUser())
	const queryClient = useQueryClient()
	const { mutateAsync } = useSignOutMutation()

	const logout = async () => {
		try {
			await mutateAsync()
		} finally {
			// Tear the client session down even if the server call fails.
			clearAccessToken()
			queryClient.clear()
			window.location.assign(window.location.origin)
		}
	}

	return { user, logout }
}

export type SessionValue = ReturnType<typeof useSession>
